export const employeeInfo = {
  designation: null,
  email: null,
  fullName: null,
  landlines: [],
  mobiles: [],
}

export const usersEmployeesColumns = [
  {
    column_name: 'ID',
    column_value: 'id',
  },
  {
    column_name: 'Name',
    column_value: 'full_name',
  },
  {
    column_name: 'Designation',
    column_value: 'designation',
  },
  {
    column_name: 'Mobile No.',
    column_value: 'mobiles',
  },
  {
    column_name: 'Landline No.',
    column_value: 'landlines',
  },
  {
    column_name: 'Email Address',
    column_value: 'email',
  },

  {
    column_name: 'Created Timestamp',
    column_value: 'created_at',
  },
  {
    column_name: 'Updated Timestamp',
    column_value: 'updated_at',
  },
  {
    column_name: 'Doc Verification',
    column_value: 'is_docs_verified',
  },
  {
    column_name: '',
    column_value: '',
  },
  {
    column_name: '',
    column_value: '',
  },
  {
    column_name: 'Status',
    column_value: 'is_active',
  },
]

export const employeeSearchFields: any = reactive({
  id: '',
  fullname: '',
  designation: '',
  mobiles: '',
  landlines: '',
  email: '',
  is_docs_verified: '',
  is_active: '',
})
